import React from "react";
import { connect } from "react-redux";
import { Auth, FC_Login } from "../../actions";
import { StoreState } from "../../reducers";
import { Link, Redirect } from "react-router-dom";
import Alert, { AlertInterface } from "../../components/Alert/Alert";
import Spinner from "../../components/Loading/Spinner";

// props for the component
interface AppProps {
  auth: Auth;
  FC_Login: Function;
}

interface AppState {
  email: string;
  password: string;
  loading: boolean;
  res: any;
  error: {
    target: string;
    msg: string;
  };
  login_pass: boolean;
  code_loading: boolean;
  redirect: boolean;
  loading_2_auth: boolean;
}

class _Login extends React.Component<AppProps, AppState> {
  constructor(props: AppProps) {
    super(props);

    this.state = {
      loading: false,
      loading_2_auth: false,
      email: "",
      password: "",
      res: null,
      error: { target: "", msg: "" },
      login_pass: false,
      code_loading: false,
      redirect: false,
    };
  }

  componentDidMount = () => {};

  loginHandler = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // check for errors
    if (this.state.email.length <= 4) {
      return this.setState({
        error: {
          target: "email",
          msg: "Please enter an email or phone number",
        },
      });
    }

    // check for errors
    if (this.state.password.length <= 4) {
      return this.setState({
        error: {
          target: "password",
          msg: "Please enter your password",
        },
      });
    }

    this.setState({
      loading: true,
      error: {
        target: "",
        msg: "",
      },
      login_pass: false,
    });
    // * Login API
    this.props.FC_Login(
      {
        username: this.state.email,
        password: this.state.password,
      },
      (status: boolean, msg: string) => {
        if (status === true) {
          this.setState({
            loading: false,
            error: {
              target: "",
              msg: "",
            },
            login_pass: true,
          });
        } else {
          this.setState({
            loading: false,
            error: {
              target: "all",
              msg: msg,
            },
            login_pass: false,
          });
        }
      }
    );
  };

  handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    this.setState({
      ...this.state,
      error: {
        target: "",
        msg: "",
      },
      [e.currentTarget.name]: e.target.value,
    } as Pick<AppState, keyof AppState>);
  };

  render() {
    if (
      this.state.redirect === true ||
      this.props.auth.isAuthenticated === true
    ) {
      return <Redirect to="/admin" />;
    }

    // check if the 2 step auth is loading
    if (this.state.loading_2_auth === true) {
      return (
        <div className="mt-16">
          <Spinner />
        </div>
      );
    }
    return (
      <div className="bg-gray-200-">
        <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-24  h-screen flex flex-wrap content-center-">
          <div className=" lg:max-w-7xl- mx-auto ">
            <div className="">
              {this.state.login_pass === true ? (
                <div className="">
                  {this.state.error.target === "all" && (
                    <div className="mx-auto w-full">
                      <Alert
                        title={this.state.error.msg}
                        theme={AlertInterface.danger}
                      />
                    </div>
                  )}
                </div>
              ) : (
                <div className="bg-white border border-gray-300 mx-auto px-4 py-5 rounded-md mt-6 sm:mx-auto">
                  <form onSubmit={this.loginHandler}>
                    <h1 className="px-2 font-extrabold text-4xl text-green-500  pt-2 pb-4">
                      User Login
                    </h1>

                    {this.state.error.target === "all" && (
                      <div className="p-2">
                        <Alert
                          title={this.state.error.msg}
                          theme={AlertInterface.danger}
                        />
                      </div>
                    )}

                    <div className="p-2">
                      <label htmlFor="email" className="d-block">
                        Email
                      </label>
                      <input
                        type="text"
                        name="email"
                        onChange={this.handleChange}
                        className={`input-white w-20 inline-block  ${
                          this.state.error?.target === "email"
                            ? "border-red-500 border-2"
                            : "border border-gray-400"
                        }`}
                        placeholder="Enter email"
                        value={this.state.email}
                        disabled={this.state.loading}
                      />
                      {this.state.error?.target === "email" && (
                        <span className="text-red-600">
                          {this.state.error?.msg}
                        </span>
                      )}
                    </div>

                    <div className="p-2">
                      <label htmlFor="username" className="d-block">
                        Password
                      </label>
                      <input
                        type="password"
                        name="password"
                        onChange={this.handleChange}
                        className={`input-white w-20 inline-block  ${
                          this.state.error?.target === "password"
                            ? "border-red-500 border-2"
                            : "border border-gray-400"
                        }`}
                        placeholder="Enter password"
                        value={this.state.password}
                        disabled={this.state.loading}
                      />
                      {this.state.error?.target === "password" && (
                        <span className="text-red-600">
                          {this.state.error?.msg}
                        </span>
                      )}
                    </div>
                    <div className="p-2">
                      <div className="flex mt-2">
                        <div className="flex-1 ">
                          <Link
                            to="/"
                            className="font-bold text-gray-600 underline"
                          >
                            Back to home
                          </Link>
                        </div>

                        <div className="flex-1  text-right">
                          <button
                            className="py-2 font-bold  px-8 rounded bg-green-500 hover:bg-green-700 text-white inline-block"
                            disabled={
                              this.state.loading || this.state.loading_2_auth
                            }
                            type="submit"
                          >
                            {this.state.loading === true ? (
                              <b className="animate__animated animate__fadeIn animate__infinite">
                                Loading...
                              </b>
                            ) : (
                              "Login"
                            )}
                          </button>
                        </div>
                      </div>

                      {/* <div className="mt-7 text-center">
                        <Link
                          to="/forget-password"
                          className="text-gray-500 hover:text-green-600 hover:underline"
                        >
                          Forget password
                        </Link>
                      </div> */}
                    </div>
                  </form>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth }: StoreState): { auth: Auth } => {
  return { auth: auth };
};

export const Login = connect(mapStateToProps, {
  FC_Login,
})(_Login);
